import React from 'react';
export function FooterSection() {
  return <footer className="bg-black text-white/70 py-12 text-center px-4 border-t border-brand-border" data-id="element-104">
      <div className="max-w-2xl mx-auto" data-id="element-105">
        <div className="flex items-center justify-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-sm uppercase mb-4" data-id="element-106">
          <span aria-hidden="true" data-id="element-107">🌟</span> PROFEPACK
        </div>
        <p className="mb-2 text-sm md:text-base" data-id="element-108">
          El sistema de planificación N°1 para docentes de Ciencias Sociales de
          primaria en Argentina.
        </p>
        <p className="italic mb-8 text-sm md:text-base" data-id="element-109">
          Porque enseñar Sociales no debería costarte todos los domingos del
          año.
        </p>
        <p className="font-medium tracking-wide text-xs text-white/50" data-id="element-110">
          © PROFEPACK — Todos los derechos reservados
        </p>
      </div>
    </footer>;
}